// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 106 ? "b9633c63" : chunkId) + "." + {"106":"57b24c262c25b805","793":"4d16c57294b89c50"}[chunkId] + ".js";
};